import * as React from "react";
import { forwardRef } from "react";
const SvgCrown = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { fill: "#8777d9", height: 24, viewBox: "0 0 24 24", width: 24, xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m5 16-2-11 5.5 5 3.5-6 3.5 6 5.5-5-2 11zm14 3c0 .6-.4 1-1 1h-12c-.6 0-1-.4-1-1v-1h14z" }));
const ForwardRef = forwardRef(SvgCrown);
export default ForwardRef;
